<body class="ltr main-body leftmenu">
    <!-- Main Content-->
    <div class="main-content side-content pt-0 ml-0">
        <div class="main-container container-fluid">
            <div class="inner-body">
                <div class="row row-sm add-form">
                    <form autocomplete="off" class="p-0" novalidate [formGroup]="slmForm ">
                        <div class="col-lg-12 col-md-12">
                            <div class="card custom-card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-8">
                                            <div class=" d-flex align-items-center pl-3">
                                                <img alt="Logo" src="../../assets/img/CollegeMaster.png"
                                                    class="mh-45px pb-2">
                                                <div class="ml-2">
                                                    <h3 class="main-content-label mb-1"><b>
                                                            Study Learning Material
                                                        </b></h3>
                                                    <p class="text-muted card-sub-title mb-0">
                                                        Study Learning Material
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4 prpl"  *ngIf="disableSlmStats">
                                            <button id="New" type="button" class="btn btn-primary floatright btn-icon-text  mt-1 mr-3"
                                              (click)="addnewrecord(dropdownArr)">
                                              <span style="display: flex; align-items: center;">
                                                <img width="20vh" src="../../assets/img/plus.gif" style="margin-right: 5px;">
                                                New Delivery Challan
                                              </span>
                                            </button>
                                          </div> 
                                    </div>
                                    <hr>
                                    <!-- session dropdown -->
                                    <div class="row clearfix">
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Session</mat-label>
                                                    <mat-select #select232 placeholder="Session" class="colorblack"
                                                        formControlName="Session" required>
                                                        <mat-select-filter *ngIf="select232.focused"
                                                            [placeholder]="'Filter'" [displayMember]="'SnName'"
                                                            [array]="sessionList"
                                                            (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                                                        <mat-option *ngFor="let item of SessionFilterList"
                                                            [value]="item.SnNo" (click)="getSnId(item.SnNo)">
                                                            {{item.SnName}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error class="margin_tp"
                                                    *ngIf="slmForm.controls['Session'].touched && slmForm.controls['Session'].errors?.required">
                                                    Mandatory
                                                </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>

                                        <!-- course dropdown -->
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Programme</mat-label>
                                                    <mat-select  #select51 panelClass="custom-select-panel"
                                                        class="colorblack" formControlName="course"
                                                        [displayMember]="'CoName'">
                                                        <mat-select-filter *ngIf="select51.focused"
                                                            [placeholder]="'Filter'" [displayMember]="'CoName'"
                                                            [array]="collegecourseList"
                                                            (filteredReturn)="filteredListCourse =$event">
                                                        </mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredListCourse"
                                                            [value]="item.CoCode " (click)="fetchCollege(item.CoCode)">
                                                            {{item.CoCode}} - {{item.CoName}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error class="margin_tp"
                                                      *ngIf="slmForm.controls['course'].touched && slmForm.controls['course'].errors?.required">
                                                      Mandatory
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>

                                        <!-- college dropdown -->
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Study Center</mat-label>
                                                    <mat-select  #select23 placeholder="CoCode" class="colorblack"
                                                        formControlName="college">
                                                        <mat-select-filter *ngIf="select23.focused"
                                                            [placeholder]="'Filter'" [displayMember]="'CgName'"
                                                            [array]="collegeList"
                                                            (filteredReturn)="filteredCollegeList =$event">
                                                        </mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredCollegeList"
                                                            [value]="item.CgCode" (click)="getClgID(item.CgCode)"
                                                            >{{item.CgCode}} -
                                                            {{item.CgName}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error class="margin_tp"
                                                      *ngIf="slmForm.controls['college'].touched && slmForm.controls['college'].errors?.required">
                                                      Mandatory
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <!-- exam dropdown -->
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Exam </mat-label>
                                                    <mat-select  #select52 class="colorblack"
                                                        formControlName="exam">
                                                        <mat-select-filter *ngIf="select52.focused"
                                                            [placeholder]="'Filter'" [displayMember]="'EmName'"
                                                            [array]="examList"
                                                            (filteredReturn)="filteredListExam =$event">
                                                        </mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredListExam"
                                                            [value]="item.EmCode" (click)="get(item)">
                                                            {{item.EmCode}} - {{item.EmName}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error class="margin_tp"
                                                      *ngIf="slmForm.controls['exam'].touched && slmForm.controls['exam'].errors?.required">
                                                       Mandatory
                                                    </mat-error>
                                                    
                                                </mat-form-field>
                                            </div>
                                        </div>

                                        <!-- branch dropdown -->
                                        <div class="col-sm-4" *ngIf="Branch">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline"
                                                        class="example-full-width">
                                                        <mat-label>Branch</mat-label>
                                                        <mat-select  #select53 class="colorblack"
                                                            formControlName="strId">
                                                            <mat-select-filter *ngIf="select53.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'item.StrId'"
                                                                [array]="BranchList"
                                                                (filteredReturn)="filteredListBranch =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListBranch"
                                                                [value]="item.StrId" (click)="getStrId(item.StrId)">
                                                                {{item.StrName}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error class="margin_tp"
                                                        *ngIf="slmForm.controls['strId'].touched && slmForm.controls['strId'].errors?.required">
                                                         Mandatory
                                                      </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Subject dropdown -->
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Course</mat-label>
                                                    <mat-select #select2334 class="colorblack"
                                                        formControlName="Subject">
                                                        <mat-select-filter *ngIf="select2334.focused"
                                                            [placeholder]="'Filter'" [displayMember]="'EsName'"
                                                            [array]="examSubList"
                                                            (filteredReturn)="filteredListExamSub =$event">
                                                        </mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredListExamSub"
                                                            [value]="item.EsId" (click)="getEsId(item.EsId)">
                                                            {{item.EsCode}} - {{item.EsName}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="slmForm.controls['Subject'].touched && slmForm.controls['Subject'].errors?.required">
                                                       Mandatory
                                                    </mat-error>
                                                </mat-form-field>
                                             </div>
                                        </div>   

                                         <!-- Medium dropdown -->
                                         <div class="col-sm-4">
                                            <div class="form-group">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Medium </mat-label>
                                                    <mat-select 
                                                       #select22 class="colorblack" formControlName="CoMediums"
                                                      >
                                                      <mat-select-filter *ngIf="select22.focused" [placeholder]="'Filter'"
                                                        [displayMember]="'CdDesc'" [array]="courseMediumList"
                                                        (filteredReturn)="filteredCourseMediumList =$event">
                                                      </mat-select-filter>
                                                      <mat-option *ngFor="let item of filteredCourseMediumList" [value]="item.CdCode" (click)="getCdCode(item.CdCode)">
                                                        {{item.CdDesc}}
                                                      </mat-option>
                                                    </mat-select>
                                                    <mat-error class="margin_tp"
                                                      *ngIf="slmForm.controls['CoMediums'].touched && slmForm.controls['CoMediums'].errors?.required">
                                                      Mandatory
                                                    </mat-error>
                                                  </mat-form-field>
                                            </div>
                                        </div>

                                        <!-- stats -->
                                         <div class="col-sm-12" *ngIf="disableSlmStats">
                                            <div class="row">
                                                  <div class="col-sm-4 ml-3 ">
                                                    <div class="form-group">
                                                        <div class="">
                                                            <div class="card custom-card text-center">
                                                                <div>
                                                                    <h6 class="mt-3">
                                                                        Number of Students: {{totalStudents}}
                                                                       </h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-4 ml-3 ">
                                                    <div class="form-group">
                                                        <div class="">
                                                            <div class="card custom-card text-center">
                                                                <div>
                                                                    <h6 class="mt-3">
                                                                        Total number of SLM Sent: {{totalSlmSent}}
                                                                       </h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-4 ml-3 ">
                                                    <div class="form-group">
                                                        <div class="">
                                                            <div class="card custom-card text-center">
                                                                <div>
                                                                    <h6 class="mt-3">
                                                                        Total number of SLM Pending: {{totalSlmPending}}
                                                                       </h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                         </div>


                                    </div>
                                    <!-- slm table -->
                                    <div class="table-responsive table-container"  *ngIf="disableSlmStats">
                                        <table appShortTable id="datatable" class="table  table-bordered  text-left">
                                          <thead>
                                            <tr>
                                              <th class="f600"> Date of Issue </th>
                                              <th class="f600"> SLM Quantity Sent </th>
                                              <th class="f600"> Remarks </th>
                                            </tr>
                                          </thead>
                                          <tbody id="table_data">
                                            <tr *ngFor="let item of slmList;">
                                              <td> {{convertedDate}} </td>
                                              <td>{{item.SlmSent}} </td>
                                              <td> {{item.Remarks}} </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>

                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</body>